<template>
  <FullScreenDialog
    v-model="dialog"
    without-padding
    title="Tipo Di Capelli"
    :route-father="routeFather"
  >
    <template v-slot:header-actions>
      <v-btn text link @click="goToNew">
        <v-icon class="mr-2">mdi-plus</v-icon> Nuovo
      </v-btn>
    </template>
    <template v-slot:toolbar-extension>
      <div class="d-flex justify-center align-center" style="width: 100%">
        <AdvancedSearch
          class="ml-2 mb-2"
          placeholder="Cerca Tipo Capelli ..."
          @apply="applyFilters"
          :show-filter-buttons="false"
        ></AdvancedSearch>
      </div>
    </template>
    <template v-slot:content>
      <div style="height: 100%; overflow-y: hidden" ref="dataTableWrapper">
        <TypeDataTable
          v-model="selected"
          loading-text="Caricamento hairTypes ..."
          :headers="headers"
          :loading="loading"
          :items="filteredHairTypes"
          :page.sync="page"
          :row-per-page.sync="rowPerPage"
          :total-pages.sync="totalPages"
          :height="dataTableHeight"
          :show-select="false"
          @edit="handleEdit"
          @delete="handleDelete"
          @dblclick:row="handleEditDoubleClick"
        ></TypeDataTable>
      </div>
    </template>
  </FullScreenDialog >
</template>

<script>
import FullScreenDialog from '@/components/common/FullScreenDialog.vue'
import StandardMenu from '@/components/common/StandardMenu.vue'
import TypeDataTable from '@/components/common/TypeDataTable.vue'
import AdvancedSearch from "@/components/common/AdvancedSearch.vue";
import hairTypesService from '@/services/hairTypes/hairTypes.service.js'

export default {
  name: "HairTypesRegistryList",
  components: {
    FullScreenDialog,
    TypeDataTable,
    StandardMenu,
    AdvancedSearch
  },
  data: function() {
    let props = this.$router.resolve({name: 'Registries'});

    return {
      dialog: true,
      loadingItems: false,
      loadingHeaders: false,
      routeFather: props.href,
      selected: undefined,
      dataTableHeightValue: 400,
      hairTypes: [],
      headers: [],
      page: 1,
      rowPerPage: 100,
      totalPages: 0,
      resizeListener: undefined,
    }
  },
  mounted: function() {
    this.fetchHeaders()
    this.fetchHairTypes()

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60

    this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    this.resizeListener = function() {
      this.dataTableHeightValue = this.$refs.dataTableWrapper.offsetHeight - 60
    }
    this.resizeListener = this.resizeListener.bind(this)
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    fetchHairTypes(filters) {
      this.loadingItems = true
      hairTypesService.list(this.page, this.rowPerPage, filters).then((results) => {
        if(this.rowPerPage != results.rowPerPage) {
          this.rowPerPage = results.rowPerPage
        }

        if(this.page != results.page) {
          this.page = results.page
        }

        this.totalPages = results.totalPages
        if(!!this.totalPages && this.totalPages < this.page) {
          this.page = this.totalPages
        }

        this.hairTypes = results.rows
        this.loadingItems = false
      })
    },
    fetchHeaders() {
      this.loadingHeaders = true
      hairTypesService.fields().then((headers) => {
        this.headers = headers
        this.loadingHeaders = false
      })
    },
    handleEdit(hairType) {
      this.$router.push({
        name: 'HairTypesRegistryEditForm',
        params: {
          id: hairType.id
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairTypesRegistryList'}).href
        }
      })
    },
    handleEditDoubleClick(row, {item: hairType}) {
      this.$router.push({
        name: 'HairTypesRegistryEditForm',
        params: {
          id: hairType.id
        },
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairTypesRegistryList'}).href
        }
      })
    },
    handleDelete(hairType) {
      let confirmed = confirm('Sei sicuro di voler eliminare ' + hairType.name + ' ?')

      if(confirmed) {
        this.loadingItems = true
        hairTypesService.archive(hairType).then(() => {
          this.fetchHairTypes()
          this.loadingItems = false
        })
      }
    },
    goToNew() {
      this.$router.push({
        name: 'HairTypesRegistryNewForm',
        query: {
          pathToGoBack: this.$router.resolve({name: 'HairTypesRegistryList'}).href
        }
      })
    },
    applyFilters(filters) {
      this.fetchHairTypes(filters);
    },
  },
  computed: {
    filteredHairTypes() {
      return this.hairTypes
    },
    loading() {
      return this.loadingItems || this.loadingHeaders
    },
    dataTableHeight() {
      return this.dataTableHeightValue + 'px'
    }
  },
  watch: {
    page() {
      this.fetchHairTypes()
    },
    rowPerPage() {
      this.fetchHairTypes()
    },
  }
}
</script>